import React, { useState, useEffect } from 'react'
import {
  Panel,
  Table,
  Icon,
  Row,
  Col,
  Form,
  SelectPicker,
  ControlLabel,
  DatePicker,
  Uploader,
  ButtonGroup,
  Modal,
  Button,
  Input,
  RadioGroup,
  Radio,
} from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { hasMinValidator, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
import TooltipButton from '../../components/buttons/TooltipButton'
import { cloneDeep, isEmpty } from 'lodash-es'
import { calculateLegalFollow, getLawSubStatus } from '../../redux/actions/legal'
import InputForm from '../../components/forms/input/InputForm'
import ReactQuillFrom from '../../components/forms/input/ReactQuill/ReactQuillFrom'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { budgetFormat, numberThousandSeparator } from '../../utils/formatterUtil'
import notification from '../../utils/notification'
import NumberFormat from 'react-number-format'

export default function SaveLawTackingForm({
  schema: _schema,
  lawType,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
  handelPreview,
  clearValue,
  litigationId,
  isFirstTimeEnableEdit,
  ...props
}) {
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table
  const {} = props

  const [formSchema, setFormSchema] = useState(_schema)
  const [trackingDate, setTrackingDate] = useState(null)
  const [isShowAlertModal, setIsShowAlertModal] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')
  const [isEnforcementJudgment, setIsEnforcementJudgment] = useState(false)

  const twoCol = {
    first: {
      _lg: 8,
      _md: 8,
      _sm: 24,
      _xs: 24,
    },
    second: {
      _lg: 8,
      _md: 8,
      _sm: 24,
      _xs: 24,
    },
  }

  const viewType = {
    DATE_TIME: 'Datetime',
    INP_INT: 'InputInt',
    DAY: 'InputDay',
  }

  // useEffect(() => {
  // console.log('pagggggggggg', isFirstTimeEnableEdit)

  // defaultValue={
  //   formSchema.edforcementDate.value
  //     ? moment(formSchema.edforcementDate.value, 'DD/MM/YYYY').toDate()
  //     : null
  // }

  // if (!isFirstTimeEnableEdit) {
  // console.log('1234567', isFirstTimeEnableEdit)
  // handelChangeSetExpDate(moment(formSchema.edforcementDate.value, 'DD/MM/YYYY').toDate())
  // handleSumAmount()
  // }
  // }, [])

  useEffect(() => {
    setTrackingDate(
      _schema?.trackingDate?.value
        ? moment(_schema?.trackingDate?.value, DATE_PICKER_FORMAT).toDate()
        : null
    )

    // setFormSchema(_schema)
    // formSchema.lawStatus.value
    setIsEnforcementJudgment(_schema.lawStatus.value == 21)
  }, [_schema])

  const getLawSubStatusOptions = async (lawStatus) => {
    startLoading()
    try {
      const response = await getLawSubStatus(lawType, lawStatus)
      var sh = cloneDeep(formSchema)
      sh.lawSubStatus.value = ''
      sh.lawSubStatus.options = response?.results || []
      setFormSchema(sh)
    } catch (e) {}
    doneLoading()
  }

  const handleChangeStatusAlertMessage = (value) => {
    console.log('value', value)

    // สถานะ : อยู่ระหว่างพิจารณาของอัยการ
    if (value == '12') {
      setIsShowAlertModal(true)
      setAlertMessage(
        `การติดตามที่เป็นสถานะ "อยู่ระหว่างพิจารณาของอัยการ" เมื่อบันทึกการติดตามแล้ว ระบบจะทำเปลี่ยนสถานะโครงเป็น "ยกเลิกโครงการ" โดยอัตโนมัติ`
      )
    }

    // สถานะ : ส่งคืนสำนักดำเนินการ
    if (value == '88') {
      setIsShowAlertModal(true)
      setAlertMessage(
        `การติดตามที่เป็นสถานะ "ส่งกลับดำนเนินการ" เมื่อบันทึกการติดตามแล้ว ระบบจะทำเปลี่ยนสถานะโครงเป็น "ดำเนินการ" โดยอัตโนมัติ`
      )
    }

    // สถานะ : ส่งคืนสำนักเพื่อปิดโครงการ
    if (value == '89') {
      setIsShowAlertModal(true)
      setAlertMessage(
        `การติดตามที่เป็นสถานะ "ส่งคืนสำนักเพื่อปิดโครงการ" เมื่อบันทึกการติดตามแล้ว ระบบจะทำเปลี่ยนสถานะโครงเป็น "ดำเนินการ" โดยอัตโนมัติ เพื่อสำนักสามารถดำเนินการส่งปิดโครงการได้`
      )
    }
  }

  const setRequiredError = (schema) => {
    notification.open('error', {
      title: `กรุณากรอก ${schema.label}`,
      duration: 10000,
    })
  }

  const handelCalculate = async () => {
    startLoading()
    try {
      var _processDate = getValues(formSchema?.trackingDate?.name)
      var processDate = _processDate ? moment(_processDate).format('YYYY-MM-DD') : ''

      var _executionDate = getValues(formSchema?.edforcementDate?.name)
      var executionDate = _executionDate ? moment(_executionDate).format('YYYY-MM-DD') : ''

      var _paymentDate = getValues(formSchema.paymentDate.name)
      var paymentDate = _paymentDate ? moment(_paymentDate).format('YYYY-MM-DD') : ''

      var paymentAmount = Number(getValues(formSchema?.amountPaid?.name)) || 0
      var interestRate = Number(getValues(formSchema?.interestRate?.name)) || 0

      // console.log('isFirstTimeEnableEdit => ', isFirstTimeEnableEdit)
      var principalAmount = Number(0)
      var judgmentAmount = Number(0)
      if (isFirstTimeEnableEdit) {
        principalAmount = Number(getValues(formSchema?.principle?.name)) || 0
        judgmentAmount = Number(getValues(formSchema?.judgmentDebt?.name)) || 0
      } else {
        principalAmount = Number(formSchema?.principle?.value) || 0
        judgmentAmount = Number(formSchema?.judgmentDebt?.value) || 0
      }

      if (executionDate == null) {
        setRequiredError(formSchema.edforcementDate)
        return false
      }

      if (interestRate == null || interestRate == '') {
        setRequiredError(formSchema.interestRate)
        return false
      }

      const req = {
        litigantionId: litigationId,
        processDate: processDate,
        executionDate: executionDate,
        paymentDate: paymentDate,
        paymentAmount: paymentAmount,
        judgmentAmount: judgmentAmount,
        principalAount: principalAmount,
        interestRate: interestRate,
      }

      const response = await calculateLegalFollow(req)
      console.log('response => ', response)

      setValue(formSchema?.remainingPrincipalAmount?.name, response?.principalRemain || 0)
      setValue(formSchema?.remainingInterest?.name, response?.interestRemain || 0)
      setValue(formSchema?.remainingBalance?.name, budgetFormat(response?.amountRemain || 0))
    } catch (e) {
      console.error('calculateLegalFollow => ', e)
    }
    doneLoading()
  }

  const viewData = (inputType, label, value, name) => {
    // console.log('view data => ', label)
    let str = ''
    switch (inputType) {
      case viewType.DATE_TIME:
        str = value ? moment(value).format('DD/MM/YYYY') : ''
        break

      case viewType.INP_INT:
        str = budgetFormat(value || 0)
        break

      case viewType.DAY:
        str = numberThousandSeparator(Number(value) || 0)
        break

      default:
        str = value ?? ''
        break
    }

    return (
      <div style={{ display: 'grid' }}>
        <ControlLabel>{label}</ControlLabel>
        <Controller
          key={name}
          name={name}
          control={control}
          defaultValue={str ?? ''}
          render={(props) => {
            return (
              <div
                style={{
                  border: '2px solid #808080',
                  borderRadius: '4px',
                  padding: '3px 6px',
                  marginTop: -2,
                  backgroundColor: '#8080800d',
                  cursor: 'no-drop',
                  minHeight: 33,
                }}
              >
                {props.value}
              </div>
            )
          }}
        />
      </div>
    )
  }

  const handelChangeSetExpDate = (val) => {
    // console.log('gggooooo', val)
    const expDate = getExpDate(val)
    setValue(formSchema?.exepEdforcementDate?.name, expDate)

    const day = getDiffDays(val, expDate)
    setValue(formSchema?.cerrentStatuteOfLimitation?.name, numberThousandSeparator(day))
  }

  const getExpDate = (val) => {
    if (!val) return null

    return moment(val).add(10, 'years').toDate()
  }

  const getDiffDays = (val, exepEdforcementDate) => {
    if (!val) return 0

    const inputDate = moment(val).startOf('day') // วันที่บังคับคดี
    const currentDate = moment().startOf('day') // วันที่ปัจจุบัน

    // ถ้ามีวันที่หมดอายุความ
    const endDate = exepEdforcementDate
      ? moment.min(currentDate, moment(exepEdforcementDate).startOf('day'))
      : currentDate

    const days = endDate.diff(inputDate, 'days') + 1

    return Math.max(days, 0)
  }

  const handleSumAmount = () => {
    var remainingPrincipalAmount = getValues(formSchema.remainingPrincipalAmount.name) ?? 0
    var remainingInterest = getValues(formSchema.remainingInterest.name) ?? 0

    var sum = Number(remainingPrincipalAmount) + Number(remainingInterest)

    setValue(formSchema?.remainingBalance?.name, budgetFormat(sum))
  }

  return (
    <>
      <Panel
        collapsible
        defaultExpanded
        bordered
        header={formSchema?.header || 'บันทึกการติดตามคดี'}
      >
        <Form>
          <Row>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage
                error={errors[formSchema.lawStatus.name]}
                style={{ marginBottom: 10 }}
              />
              <ControlLabel>
                {requiredFiled(formSchema.lawStatus.validators, formSchema.lawStatus.label)}
              </ControlLabel>

              <Controller
                name={formSchema.lawStatus.name}
                control={control}
                defaultValue={formSchema.lawStatus.value}
                rules={isValidators(formSchema.lawStatus.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.lawStatus.options}
                      searchable={true}
                      // disabled={formSchema.lawStatus.disabled}
                      value={props.value}
                      block
                      placeholder={
                        formSchema.lawStatus.hint || `เลือก${formSchema.lawStatus.label}`
                      }
                      onChange={(value) => {
                        // console.log('lawStatusvalue => ', value)
                        props.onChange(value)

                        setIsEnforcementJudgment(value == 21)

                        getLawSubStatusOptions(value)

                        handleChangeStatusAlertMessage(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage
                error={errors[formSchema.lawSubStatus.name]}
                style={{ marginBottom: 10 }}
              />
              <ControlLabel>
                {formSchema.lawSubStatus.options.length > 0
                  ? requiredFiled(formSchema.lawSubStatus.validators, formSchema.lawSubStatus.label)
                  : formSchema.lawSubStatus.label}
              </ControlLabel>
              <Controller
                name={formSchema.lawSubStatus.name}
                control={control}
                defaultValue={formSchema.lawSubStatus.value}
                rules={
                  formSchema.lawSubStatus.options.length > 0
                    ? isValidators(formSchema.lawSubStatus.validators)
                    : {}
                }
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.lawSubStatus.options}
                      searchable={true}
                      value={props.value}
                      block
                      placeholder={
                        formSchema.lawSubStatus.hint || `เลือก${formSchema.lawSubStatus.label}`
                      }
                      disabled={
                        formSchema.lawSubStatus.options.length < 1 ||
                        formSchema.lawSubStatus.disabled
                      }
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={twoCol.second._lg}
              md={twoCol.second._md}
              sm={twoCol.second._sm}
              xs={twoCol.second._xs}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <ErrorMessage
                error={errors[formSchema.trackingDate.name]}
                style={{ marginBottom: 10 }}
              />
              <ControlLabel>
                {requiredFiled(formSchema.trackingDate.validators, formSchema.trackingDate.label)}
              </ControlLabel>

              <Controller
                key={formSchema.trackingDate.name}
                name={formSchema.trackingDate.name}
                control={control}
                defaultValue={
                  formSchema.trackingDate.value
                    ? moment(formSchema.trackingDate.value, 'DD/MM/YYYY').toDate()
                    : null
                }
                // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                render={(props) => {
                  return (
                    <DatePicker
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      value={props.value}
                      onChange={(value) => {
                        // const date = moment(value).format(DATE_PICKER_FORMAT)
                        props.onChange(value)
                        setTrackingDate(value)
                      }}
                    />
                  )
                }}
              />
            </Col>

            {formSchema?.edforcementDate && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {!isFirstTimeEnableEdit ? (
                  <>
                    {viewData(
                      viewType.DATE_TIME,
                      formSchema?.edforcementDate?.label,
                      formSchema?.edforcementDate?.value,
                      formSchema?.edforcementDate?.name
                    )}
                  </>
                ) : (
                  <>
                    <ErrorMessage
                      error={errors[formSchema.edforcementDate.name]}
                      style={{ marginBottom: 10 }}
                    />
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.edforcementDate.validators,
                        formSchema.edforcementDate.label
                      )}
                    </ControlLabel>

                    <Controller
                      key={formSchema.edforcementDate.name}
                      name={formSchema.edforcementDate.name}
                      control={control}
                      defaultValue={
                        formSchema.edforcementDate.value
                          ? moment(formSchema.edforcementDate.value).toDate()
                          : null
                      }
                      // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                      render={(props) => {
                        return (
                          <DatePicker
                            format="DD/MM/YYYY"
                            locale={LOCAL_DAY_TH}
                            block
                            value={props.value}
                            onChange={(value) => {
                              // const date = moment(value).format(DATE_PICKER_FORMAT)

                              handelChangeSetExpDate(value)

                              props.onChange(value)
                              // setTrackingDate(value)
                            }}
                          />
                        )
                      }}
                    />
                  </>
                )}
              </Col>
            )}

            {formSchema?.cerrentStatuteOfLimitation && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {/* {formSchema.cerrentStatuteOfLimitation.disabled ? ( */}
                <>
                  {viewData(
                    viewType.DAY,
                    formSchema?.cerrentStatuteOfLimitation?.label,
                    formSchema?.cerrentStatuteOfLimitation?.value,
                    formSchema?.cerrentStatuteOfLimitation?.name
                  )}
                </>
                {/* ) : (
                  <>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.cerrentStatuteOfLimitation.validators,
                        formSchema.cerrentStatuteOfLimitation.label
                      )}
                    </ControlLabel>
                    <ErrorMessage error={errors[formSchema.cerrentStatuteOfLimitation.name]} />
                    <Controller
                      name={formSchema.cerrentStatuteOfLimitation.name}
                      control={control}
                      defaultValue={formSchema.cerrentStatuteOfLimitation.value}
                      rules={isValidators(formSchema.cerrentStatuteOfLimitation.validators)}
                      render={(props) => {
                        return (
                          <Input
                            placeholder={'ระบุ' + formSchema.cerrentStatuteOfLimitation.label}
                            value={props.value}
                            onKeyDown={(e) => {
                              const hasMin = hasMinValidator(
                                formSchema.cerrentStatuteOfLimitation.validators
                              )

                              if (['e', 'E', '+'].includes(e.key)) {
                                e.preventDefault()
                              }

                              if (hasMin && e.key === '-') {
                                e.preventDefault()
                              }
                            }}
                            onChange={(value, e) => {
                              const hasMin = hasMinValidator(
                                formSchema.cerrentStatuteOfLimitation.validators
                              )

                              if (hasMin && String(value).includes('-')) {
                                return
                              }

                              props.onChange(value)
                            }}
                            type="number"
                            disabled={formSchema.cerrentStatuteOfLimitation.disabled}
                          />
                        )
                      }}
                    />
                  </>
                )} */}
              </Col>
            )}
          </Row>

          <Row>
            {formSchema?.exepEdforcementDate && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {!isFirstTimeEnableEdit ? (
                  <>
                    {viewData(
                      viewType.DATE_TIME,
                      formSchema?.exepEdforcementDate?.label,
                      formSchema?.exepEdforcementDate?.value,
                      formSchema.exepEdforcementDate.name
                    )}
                  </>
                ) : (
                  <>
                    <ErrorMessage
                      error={errors[formSchema.exepEdforcementDate.name]}
                      style={{ marginBottom: 10 }}
                    />
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.exepEdforcementDate.validators,
                        formSchema.exepEdforcementDate.label
                      )}
                    </ControlLabel>

                    <Controller
                      key={formSchema.exepEdforcementDate.name}
                      name={formSchema.exepEdforcementDate.name}
                      control={control}
                      defaultValue={
                        formSchema.exepEdforcementDate.value
                          ? moment(formSchema.exepEdforcementDate.value).toDate()
                          : null
                      }
                      // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                      render={(props) => {
                        return (
                          <DatePicker
                            format="DD/MM/YYYY"
                            locale={LOCAL_DAY_TH}
                            block
                            value={props.value}
                            onChange={(value) => {
                              // const date = moment(value).format(DATE_PICKER_FORMAT)
                              props.onChange(value)
                              // setTrackingDate(value)
                            }}
                          />
                        )
                      }}
                    />
                  </>
                )}
              </Col>
            )}

            {formSchema.judgmentDebt && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {!isFirstTimeEnableEdit ? (
                  <>
                    {viewData(
                      viewType.INP_INT,
                      formSchema?.judgmentDebt?.label,
                      formSchema?.judgmentDebt?.value,
                      formSchema.judgmentDebt.name
                    )}
                  </>
                ) : (
                  <>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.judgmentDebt.validators,
                        formSchema.judgmentDebt.label
                      )}
                    </ControlLabel>
                    <ErrorMessage error={errors[formSchema.judgmentDebt.name]} />
                    <Controller
                      name={formSchema.judgmentDebt.name}
                      control={control}
                      defaultValue={formSchema.judgmentDebt.value}
                      rules={isValidators(formSchema.judgmentDebt.validators)}
                      render={(props) => {
                        return (
                          <NumberFormat
                            className={classNames('rs-input', errors[`masterCost`] && 'is-error')}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            value={props.value}
                            onValueChange={(value) => {
                              props.onChange(value.floatValue)
                            }}
                            disabled={formSchema.judgmentDebt.disabled}
                            allowNegative={!hasMinValidator(formSchema.judgmentDebt.validators)}
                          />
                          // <Input
                          //   placeholder={'ระบุ' + formSchema.judgmentDebt.label}
                          //   value={props.value}
                          //   onKeyDown={(e) => {
                          //     const hasMin = hasMinValidator(formSchema.judgmentDebt.validators)

                          //     if (['e', 'E', '+'].includes(e.key)) {
                          //       e.preventDefault()
                          //     }

                          //     if (hasMin && e.key === '-') {
                          //       e.preventDefault()
                          //     }
                          //   }}
                          //   onChange={(value, e) => {
                          //     const hasMin = hasMinValidator(formSchema.judgmentDebt.validators)

                          //     if (hasMin && String(value).includes('-')) {
                          //       return
                          //     }

                          //     props.onChange(value)
                          //   }}
                          //   type="number"
                          //   disabled={formSchema.judgmentDebt.disabled}
                          // />
                        )
                      }}
                    />
                  </>
                )}
              </Col>
            )}

            {formSchema.principle && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {!isFirstTimeEnableEdit ? (
                  <>
                    {viewData(
                      viewType.INP_INT,
                      formSchema?.principle?.label,
                      formSchema?.principle?.value,
                      formSchema.principle.name
                    )}
                  </>
                ) : (
                  <>
                    <ControlLabel>
                      {requiredFiled(formSchema.principle.validators, formSchema.principle.label)}
                    </ControlLabel>
                    <ErrorMessage error={errors[formSchema.principle.name]} />
                    <Controller
                      name={formSchema.principle.name}
                      control={control}
                      defaultValue={formSchema.principle.value}
                      rules={isValidators(formSchema.principle.validators)}
                      render={(props) => {
                        return (
                          <NumberFormat
                            className={classNames('rs-input', errors[`masterCost`] && 'is-error')}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            value={props.value}
                            onValueChange={(value) => {
                              props.onChange(value.floatValue)
                            }}
                            disabled={formSchema.principle.disabled}
                            allowNegative={!hasMinValidator(formSchema.principle.validators)}
                          />
                          // <Input
                          //   placeholder={'ระบุ' + formSchema.principle.label}
                          //   value={props.value}
                          //   onKeyDown={(e) => {
                          //     const hasMin = hasMinValidator(formSchema.principle.validators)

                          //     if (['e', 'E', '+'].includes(e.key)) {
                          //       e.preventDefault()
                          //     }

                          //     if (hasMin && e.key === '-') {
                          //       e.preventDefault()
                          //     }
                          //   }}
                          //   onChange={(value, e) => {
                          //     const hasMin = hasMinValidator(formSchema.principle.validators)

                          //     if (hasMin && String(value).includes('-')) {
                          //       return
                          //     }

                          //     props.onChange(value)
                          //   }}
                          //   type="number"
                          //   disabled={formSchema.principle.disabled}
                          // />
                        )
                      }}
                    />
                  </>
                )}
              </Col>
            )}
          </Row>

          <Row>
            {formSchema.interestRate && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {/* {!isFirstTimeEnableEdit? (
                  <>
                    {viewData(
                      viewType.INP_INT,
                      formSchema?.interestRate?.label,
                      formSchema?.interestRate?.value,
                      formSchema.interestRate.name
                    )}
                  </>
                ) : ( */}
                <>
                  <ControlLabel>
                    {requiredFiled(
                      formSchema.interestRate.validators,
                      formSchema.interestRate.label
                    )}
                  </ControlLabel>
                  <ErrorMessage error={errors[formSchema.interestRate.name]} />
                  <Controller
                    name={formSchema.interestRate.name}
                    control={control}
                    defaultValue={formSchema.interestRate.value}
                    rules={isValidators(formSchema.interestRate.validators)}
                    render={(props) => {
                      return (
                        <NumberFormat
                          className={classNames('rs-input', errors[`masterCost`] && 'is-error')}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale
                          value={props.value}
                          onValueChange={(value) => {
                            props.onChange(value.floatValue)
                          }}
                          disabled={formSchema.interestRate.disabled}
                          allowNegative={!hasMinValidator(formSchema.interestRate.validators)}
                        />
                        // <Input
                        //   placeholder={'ระบุ' + formSchema.interestRate.label}
                        //   value={props.value}
                        //   onKeyDown={(e) => {
                        //     const hasMin = hasMinValidator(formSchema.interestRate.validators)

                        //     if (['e', 'E', '+'].includes(e.key)) {
                        //       e.preventDefault()
                        //     }

                        //     if (hasMin && e.key === '-') {
                        //       e.preventDefault()
                        //     }
                        //   }}
                        //   onChange={(value, e) => {
                        //     const hasMin = hasMinValidator(formSchema.interestRate.validators)

                        //     if (hasMin && String(value).includes('-')) {
                        //       return
                        //     }

                        //     props.onChange(value)
                        //   }}
                        //   type="number"
                        //   disabled={formSchema.interestRate.disabled}
                        // />
                      )
                    }}
                  />
                </>
                {/* )} */}
              </Col>
            )}
            {formSchema?.paymentDate && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {/* {formSchema.paymentDate.disabled ? (
                  <>
                    {viewData(
                      viewType.DATE_TIME,
                      formSchema?.paymentDate?.label,
                      formSchema?.paymentDate?.value,
                      formSchema.paymentDate.name
                    )}
                  </>
                ) : ( */}
                <>
                  <ErrorMessage
                    error={errors[formSchema.paymentDate.name]}
                    style={{ marginBottom: 10 }}
                  />
                  <ControlLabel>
                    {requiredFiled(formSchema.paymentDate.validators, formSchema.paymentDate.label)}
                  </ControlLabel>

                  <Controller
                    key={formSchema.paymentDate.name}
                    name={formSchema.paymentDate.name}
                    control={control}
                    defaultValue={
                      formSchema.paymentDate.value
                        ? moment(formSchema.paymentDate.value).toDate()
                        : null
                    }
                    // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format="DD/MM/YYYY"
                          locale={LOCAL_DAY_TH}
                          block
                          value={props.value}
                          onChange={(value) => {
                            // const date = moment(value).format(DATE_PICKER_FORMAT)
                            props.onChange(value)
                            // setTrackingDate(value)
                          }}
                          disabledDate={(date) => {
                            const trackingDate = getValues(formSchema.trackingDate.name)

                            // ถ้าไม่มีวันที่ดำเนินการ ให้ใช้วันที่ปัจจุบัน
                            const maxDate = trackingDate
                              ? moment(trackingDate).endOf('day')
                              : moment().endOf('day')

                            // disable วันที่ที่มากกว่า maxDate
                            return moment(date).isAfter(maxDate)
                          }}
                        />
                      )
                    }}
                  />
                </>
                {/* )} */}
              </Col>
            )}
            {formSchema.amountPaid && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {/* {formSchema.amountPaid.disabled ? (
                  <>
                    {viewData(
                      viewType.INP_INT,
                      formSchema?.amountPaid?.label,
                      formSchema?.amountPaid?.value,
                      formSchema.amountPaid.name
                    )}
                  </>
                ) : ( */}
                <>
                  <ControlLabel>
                    {requiredFiled(formSchema.amountPaid.validators, formSchema.amountPaid.label)}
                  </ControlLabel>
                  <ErrorMessage error={errors[formSchema.amountPaid.name]} />
                  <Controller
                    name={formSchema.amountPaid.name}
                    control={control}
                    defaultValue={formSchema.amountPaid.value}
                    rules={isValidators(formSchema.amountPaid.validators)}
                    render={(props) => {
                      return (
                        <NumberFormat
                          className={classNames('rs-input', errors[`masterCost`] && 'is-error')}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale
                          value={props.value}
                          onValueChange={(value) => {
                            props.onChange(value.floatValue)
                          }}
                          disabled={formSchema.amountPaid.disabled}
                          allowNegative={!hasMinValidator(formSchema.amountPaid.validators)}
                        />
                        // <Input
                        //   placeholder={'ระบุ' + formSchema.amountPaid.label}
                        //   value={props.value}
                        //   onKeyDown={(e) => {
                        //     const hasMin = hasMinValidator(formSchema.amountPaid.validators)

                        //     if (['e', 'E', '+'].includes(e.key)) {
                        //       e.preventDefault()
                        //     }

                        //     if (hasMin && e.key === '-') {
                        //       e.preventDefault()
                        //     }
                        //   }}
                        //   onChange={(value, e) => {
                        //     const hasMin = hasMinValidator(formSchema.amountPaid.validators)

                        //     if (hasMin && String(value).includes('-')) {
                        //       return
                        //     }

                        //     props.onChange(value)
                        //   }}
                        //   type="number"
                        //   disabled={formSchema.amountPaid.disabled}
                        // />
                      )
                    }}
                  />
                </>
                {/* )} */}
              </Col>
            )}
          </Row>

          {formSchema?.buttonText && isEnforcementJudgment && (
            <Row>
              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <SaveButton
                  icon="calculator"
                  children={formSchema?.buttonText?.calculate ?? ''}
                  onClick={() => {
                    handelCalculate()
                  }}
                />
              </Col>
            </Row>
          )}

          <Row>
            {formSchema.remainingPrincipalAmount && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {/* {formSchema.remainingPrincipalAmount.disabled ? (
                  <>
                    {viewData(
                      viewType.INP_INT,
                      formSchema?.remainingPrincipalAmount?.label,
                      formSchema?.remainingPrincipalAmount?.value,
                      formSchema.remainingPrincipalAmount.name
                    )}
                  </>
                ) : ( */}
                <>
                  <ControlLabel>
                    {requiredFiled(
                      formSchema.remainingPrincipalAmount.validators,
                      formSchema.remainingPrincipalAmount.label
                    )}
                  </ControlLabel>
                  <ErrorMessage error={errors[formSchema.remainingPrincipalAmount.name]} />
                  <Controller
                    name={formSchema.remainingPrincipalAmount.name}
                    control={control}
                    defaultValue={formSchema.remainingPrincipalAmount.value}
                    rules={isValidators(formSchema.remainingPrincipalAmount.validators)}
                    render={(props) => {
                      return (
                        <NumberFormat
                          className={classNames('rs-input', errors[`masterCost`] && 'is-error')}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale
                          value={props.value}
                          onValueChange={(value) => {
                            props.onChange(value.floatValue)
                          }}
                          disabled={formSchema.remainingPrincipalAmount.disabled}
                          allowNegative={
                            !hasMinValidator(formSchema.remainingPrincipalAmount.validators)
                          }
                        />
                        // <Input
                        //   placeholder={'ระบุ' + formSchema.remainingPrincipalAmount.label}
                        //   value={props.value}
                        //   onKeyDown={(e) => {
                        //     const hasMin = hasMinValidator(
                        //       formSchema.remainingPrincipalAmount.validators
                        //     )

                        //     if (['e', 'E', '+'].includes(e.key)) {
                        //       e.preventDefault()
                        //     }

                        //     if (hasMin && e.key === '-') {
                        //       e.preventDefault()
                        //     }
                        //   }}
                        //   onChange={(value, e) => {
                        //     const hasMin = hasMinValidator(
                        //       formSchema.remainingPrincipalAmount.validators
                        //     )

                        //     if (hasMin && String(value).includes('-')) {
                        //       return
                        //     }

                        //     props.onChange(value)

                        //     handleSumAmount()
                        //   }}
                        //   type="number"
                        //   disabled={formSchema.remainingPrincipalAmount.disabled}
                        // />
                      )
                    }}
                  />
                </>
                {/* )} */}
              </Col>
            )}

            {formSchema.remainingInterest && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {/* {formSchema.remainingInterest.disabled ? (
                  <>
                    {viewData(
                      viewType.INP_INT,
                      formSchema?.remainingInterest?.label,
                      formSchema?.remainingInterest?.value,
                      formSchema.remainingInterest.name
                    )}
                  </>
                ) : ( */}
                <>
                  <ControlLabel>
                    {requiredFiled(
                      formSchema.remainingInterest.validators,
                      formSchema.remainingInterest.label
                    )}
                  </ControlLabel>
                  <ErrorMessage error={errors[formSchema.remainingInterest.name]} />
                  <Controller
                    name={formSchema.remainingInterest.name}
                    control={control}
                    defaultValue={formSchema.remainingInterest.value}
                    rules={isValidators(formSchema.remainingInterest.validators)}
                    render={(props) => {
                      return (
                        <NumberFormat
                          className={classNames('rs-input', errors[`masterCost`] && 'is-error')}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale
                          value={props.value}
                          onValueChange={(value) => {
                            props.onChange(value.floatValue)
                          }}
                          disabled={formSchema.remainingInterest.disabled}
                          allowNegative={!hasMinValidator(formSchema.remainingInterest.validators)}
                        />
                        // <Input
                        //   placeholder={'ระบุ' + formSchema.remainingInterest.label}
                        //   value={props.value}
                        //   onKeyDown={(e) => {
                        //     const hasMin = hasMinValidator(formSchema.remainingInterest.validators)

                        //     if (['e', 'E', '+'].includes(e.key)) {
                        //       e.preventDefault()
                        //     }

                        //     if (hasMin && e.key === '-') {
                        //       e.preventDefault()
                        //     }
                        //   }}
                        //   onChange={(value, e) => {
                        //     const hasMin = hasMinValidator(formSchema.remainingInterest.validators)

                        //     if (hasMin && String(value).includes('-')) {
                        //       return
                        //     }

                        //     props.onChange(value)

                        //     handleSumAmount()
                        //   }}
                        //   type="number"
                        //   disabled={formSchema.remainingInterest.disabled}
                        // />
                      )
                    }}
                  />
                </>
                {/* )} */}
              </Col>
            )}

            {formSchema.remainingBalance && isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {/* {formSchema.remainingBalance.disabled ? ( */}
                <>
                  {viewData(
                    viewType.INP_INT,
                    formSchema?.remainingBalance?.label,
                    formSchema?.remainingBalance?.value,
                    formSchema.remainingBalance.name
                  )}
                </>
                {/* ) : (
                  <>
                    <ControlLabel>
                      {requiredFiled(
                        formSchema.remainingBalance.validators,
                        formSchema.remainingBalance.label
                      )}
                    </ControlLabel>
                    <ErrorMessage error={errors[formSchema.remainingBalance.name]} />
                    <Controller
                      name={formSchema.remainingBalance.name}
                      control={control}
                      defaultValue={formSchema.remainingBalance.value}
                      rules={isValidators(formSchema.remainingBalance.validators)}
                      render={(props) => {
                        return (
                          <Input
                            placeholder={'ระบุ' + formSchema.remainingBalance.label}
                            value={props.value}
                            onKeyDown={(e) => {
                              const hasMin = hasMinValidator(formSchema.remainingBalance.validators)

                              if (['e', 'E', '+'].includes(e.key)) {
                                e.preventDefault()
                              }

                              if (hasMin && e.key === '-') {
                                e.preventDefault()
                              }
                            }}
                            onChange={(value, e) => {
                              const hasMin = hasMinValidator(formSchema.remainingBalance.validators)

                              if (hasMin && String(value).includes('-')) {
                                return
                              }

                              props.onChange(value)
                            }}
                            type="number"
                            disabled={formSchema.remainingBalance.disabled}
                          />
                        )
                      }}
                    />
                  </>
                )} */}
              </Col>
            )}
          </Row>

          <Row>
            {isEnforcementJudgment && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                {formSchema?.riskLevel && (
                  <>
                    <ControlLabel>
                      {formSchema.riskLevel.options.length > 0
                        ? requiredFiled(formSchema.riskLevel.validators, formSchema.riskLevel.label)
                        : formSchema.riskLevel.label}
                    </ControlLabel>
                    <ErrorMessage
                      error={errors[formSchema.riskLevel.name]}
                      style={{ marginBottom: 10 }}
                    />
                    <br />
                    <Controller
                      name={formSchema.riskLevel.name}
                      control={control}
                      defaultValue={formSchema.riskLevel.value || '1'}
                      rule={register(isValidators(formSchema.riskLevel.validators))}
                      render={(props) => {
                        return (
                          <RadioGroup
                            value={props.value}
                            onChange={(value) => {
                              props.onChange(value)
                            }}
                            inline
                          >
                            {formSchema.riskLevel.options.map((item) => (
                              <Radio
                                key={item.value}
                                value={item.value}
                                disabled={formSchema.disabled}
                              >
                                {item.label}
                              </Radio>
                            ))}
                          </RadioGroup>
                        )
                      }}
                    />
                  </>
                )}
              </Col>
            )}
          </Row>

          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <ReactQuillFrom
                schema={formSchema.noteOfTracking}
                toolbar={[]}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                toolbars={[['bold', 'italic', 'underline']]}
              />
              {/* <InputForm
                schema={formSchema.noteOfTracking}
                rows={5}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                onChange={(value) => {
                  // setTargetUnit(value)
                }}
              /> */}
            </Col>
          </Row>

          <Row>
            <Col
              lg={24}
              md={24}
              sm={24}
              xs={24}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              <Controller
                name={'file'}
                control={control}
                defaultValue={undefined}
                render={(props) => {
                  return (
                    <Uploader
                      draggable
                      autoUpload={false}
                      multiple={true}
                      fileList={props.value || []}
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          props.onChange(fileList)
                        }
                      }}
                    >
                      <div>
                        <div
                          style={{ lineHeight: '50px' }}
                          className={classNames('uploader', `${theme[0]}-background`)}
                        >
                          <Icon size="4x" icon="upload2" />
                          <small className="uploder__text">
                            <p style={{ wordBreak: 'break-word' }}>
                              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                            </p>
                          </small>
                        </div>
                      </div>
                    </Uploader>
                  )
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col
              lg={24}
              md={24}
              sm={24}
              xs={24}
              style={{
                marginTop: '5px',
                padding: '8px',
              }}
            >
              {formSchema?.attachFiles?.value && (
                <Table height={300} wordWrap bordered data={formSchema?.attachFiles?.value}>
                  <Column width={90} align="center" fixed>
                    <HeaderCell>ไฟล์ที่</HeaderCell>
                    <Cell>
                      {(_, index) => {
                        return index + 1
                      }}
                    </Cell>
                  </Column>
                  <Column minWidth={300} flexGrow={1}>
                    <HeaderCell>ชื่อไฟล์</HeaderCell>
                    <Cell>
                      {(rowData, index) => {
                        return validateEditFileName(rowData, index)
                      }}
                    </Cell>
                  </Column>

                  <Column width={200} align="center">
                    <HeaderCell></HeaderCell>
                    <Cell>
                      {(rowData, index) => {
                        return (
                          <ButtonGroup>
                            <TooltipButton
                              isStart={true}
                              icon="eye"
                              tooltip={`แสดง`}
                              // disabled={loading}
                              // onClick={(e) => onPreview(rowData)}
                            ></TooltipButton>
                            <TooltipButton
                              isStart={false}
                              icon="download"
                              tooltip={`ดาวน์โหลด`}
                              // disabled={loading}
                              // onClick={(e) => onDownload(rowData)}
                            ></TooltipButton>
                            {/* {!disabledEdit && ( */}
                            {/* <TooltipButton
                            isStart={false}
                            icon="pencil"
                            tooltip={`แก้ไข`}
                            // disabled={selectEditeIndex == index}
                            // onClick={(e) => handleEditFile(rowData, index)}
                          ></TooltipButton> */}
                            {/* )} */}
                            <TooltipButton
                              isStart={false}
                              icon="trash-o"
                              tooltip={`ลบ`}
                              // disabled={loading}
                              // onClick={(e) => handleDeleteFile(index)}
                            ></TooltipButton>
                          </ButtonGroup>
                        )
                      }}
                    </Cell>
                  </Column>
                </Table>
              )}
            </Col>
          </Row>
        </Form>

        {/* <hr />

        {formSchema.buttonText && (
          <ButtonPanelWidget
            isEdit={true}
            isDisabled={false}
            isError={isError}
            buttonText={formSchema.buttonText}
            onSave={handlerOnSave}
            onCancel={handlerOnCancel}
          />
        )} */}
      </Panel>

      <Modal show={isShowAlertModal} onHide={() => setIsShowAlertModal(false)} backdrop="static">
        <Modal.Header>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ paddingTop: '0.5rem' }}>{alertMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setIsShowAlertModal(false)} appearance="primary">
            รับทราบ
          </Button>
          {/* <Button onClick={() => setIsShowAlertModal(false)} appearance="subtle">
              ปิด
            </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  )
}
